var _defs, _g, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscabeau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1021 1802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7e7e7e;}.cls-2{fill:#acacac;}.cls-3{fill:#f8b71f;}.cls-4{fill:#ce8228;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "escabeau") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "escabeau"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1660,929l-20-4,92-386-67-12-208,34L932.24,2145.22,933,2158l16,12,78-26,2-20,55-166,208,82-60,259,1,20,24,9,79-36,1-20,178-798,95,448,10,6,23-10-24.73-107.84L1881,1880l36,135,18,8,18-13Zm36,281-118-8c0-2,5-24,5-24s34,4,40,3,6-11,6-11l56,3Zm-16-61-90-5,36-160,11,8ZM1404,984l11,10,31,152-99,8Zm-94,979-205-73,65-193,188,49Zm62-276-185-46,68-204,170,28Zm63-268-165-23,68-211,120,5,15,72Zm65-278h-19l-38-191-22-16,109-336,100-15Zm109,631-74-378,33-149,140,9,163,588Z",
    transform: "translate(-932 -527)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 1618 12 1626 533 60 514.95 63.43 0 1618"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1232,2299l20,8L1658,557l-23,3C1481,1204.69,1340.47,1805,1232,2299Z",
    transform: "translate(-932 -527)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "255 899.5 262.52 875.9 499.76 910 493 938 255 899.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "170 1152.5 177.52 1128.9 431 1194 426 1219 170 1152.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "88 1405.5 95.52 1381.9 366 1486 360 1513 88 1405.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "337 653 345.52 626.9 560 636 555 665 337 653"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1 1631 0.24 1618.22 12 1626 97 1597 95 1617 17 1643 1 1631"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "301 1793 300 1772 320 1780 405 1745 404 1766 323 1802 301 1793"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "18 1646 12 1626 97 1597 95 1620 18 1646"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "323 1802 320 1780 405 1745 404 1766 323 1802"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1637,992h16l282,1031-18-8C1807,1617.6,1706.5,1252.52,1637,992Z",
    transform: "translate(-932 -527)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "483 467 498 467 527 617 514 619 483 467"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "526 663 537 663 546 710 539 731 526 663"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "981.97 1477.07 999.54 1483.35 1018.02 1472 1021 1483 1003 1496 985 1488 981.97 1477.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "676.05 1385.83 686 1391 708.91 1381.9 711 1391 688 1401 678 1395 676.05 1385.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1003 1496 1000 1483 1018 1472 1021 1483 1003 1496"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "688 1401 686 1391 709 1382 711 1391 688 1401"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "583 947 591 913 686 1391 676 1386 583 947"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "525 34 733 0 800 12 794.06 36.92 726 30 515 63 525 34"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1323.5,
    cy: 2262,
    rx: 9,
    ry: 5.5,
    transform: "translate(-2111.44 2511.9) rotate(-76.91)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1270.5,
    cy: 2285,
    rx: 9,
    ry: 5.5,
    transform: "translate(-2174.84 2478.07) rotate(-76.91)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1016.74,
    cy: 2116.44,
    rx: 7.4,
    ry: 4.52,
    transform: "translate(-2206.96 2100.5) rotate(-76.91)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 965.18,
    cy: 2133.34,
    rx: 7.4,
    ry: 4.52,
    transform: "translate(-2263.3 2063.36) rotate(-76.91)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscabeau);
export default __webpack_public_path__ + "static/media/escabeau.98f3578541637c2e8bc5dac115b79d52.svg";
export { ForwardRef as ReactComponent };